(function () {
  function list(nodes) {
    return Array.prototype.slice.call(nodes);
  }

  function initSection(root) {
    if (!root || root.dataset.psInit === 'true') return;
    root.dataset.psInit = 'true';
    root.classList.add('ps-js');

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var viewport = root.querySelector('[data-ps-viewport]');
    var track = root.querySelector('[data-ps-track]');

    var revealEls = root.querySelectorAll('[data-ps-reveal]');
    if (reduce || !('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
      revealEls.forEach(function (el) { io.observe(el); });
    }

    if (!viewport || !track || !window.UrbPsBelt) return;

    var tabsEl = root.querySelector('[data-ps-tabs]');
    var tabs = list(root.querySelectorAll('.products-slider__tab'));
    var button = root.querySelector('[data-ps-button]');
    var prevArrow = root.querySelector('[data-ps-arrow="prev"]');
    var nextArrow = root.querySelector('[data-ps-arrow="next"]');

    var starts = [];
    var current = -1;
    var moveRaf = null;
    var jumpT = null;
    var belt = null;

    function tabsFade() {
      if (!tabsEl) return;
      var max = tabsEl.scrollWidth - tabsEl.clientWidth;
      tabsEl.classList.toggle('is-fade-start', tabsEl.scrollLeft > 4);
      tabsEl.classList.toggle('is-fade-end', max > 4 && tabsEl.scrollLeft < max - 4);
    }

    function keepTabVisible(tab) {
      if (!tabsEl || !tab) return;
      if (tabsEl.scrollWidth - tabsEl.clientWidth < 4) return;
      var tr = tab.getBoundingClientRect();
      var br = tabsEl.getBoundingClientRect();
      tabsEl.scrollLeft += (tr.left + tr.width / 2) - (br.left + br.width / 2);
    }

    function setActive(index) {
      if (index === current || index < 0) return;
      current = index;
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.classList.toggle('is-active', on);
        if (on) { tab.setAttribute('aria-current', 'true'); } else { tab.removeAttribute('aria-current'); }
      });
      var active = tabs[index];
      if (!active) return;
      if (button && active.dataset.psUrl) button.setAttribute('href', active.dataset.psUrl);
      keepTabVisible(active);
      tabsFade();
    }

    function indexAt(position) {
      var index = 0;
      for (var i = 0; i < starts.length; i++) {
        if (position >= starts[i].pos - 2) index = i;
      }
      return index;
    }

    function sync() {
      if (!starts.length) return;
      setActive(indexAt(belt.position()));
    }

    function onMove() {
      if (moveRaf) return;
      moveRaf = window.requestAnimationFrame(function () {
        moveRaf = null;
        sync();
      });
    }

    function measure() {
      starts = [];
      var items = list(track.querySelectorAll('.products-slider__item:not([data-ps-clone])'));
      if (!items.length) return;
      var home = belt ? belt.home() : 0;
      items.forEach(function (item) {
        if (!item.hasAttribute('data-ps-first')) return;
        starts.push({ el: item, pos: home + (item.offsetLeft - items[0].offsetLeft) });
      });
      var scrollable = viewport.scrollWidth - viewport.clientWidth > 4;
      if (prevArrow) prevArrow.hidden = !scrollable;
      if (nextArrow) nextArrow.hidden = !scrollable;
      current = -1;
      sync();
      tabsFade();
    }

    function goTo(index) {
      var entry = starts[index];
      if (!entry) return;
      belt.pause();
      window.clearTimeout(jumpT);
      if (reduce) {
        belt.align(entry.el);
        current = -1;
        setActive(index);
        belt.resume();
        return;
      }
      track.classList.add('is-jump');
      jumpT = window.setTimeout(function () {
        belt.align(entry.el);
        current = -1;
        setActive(index);
        track.classList.remove('is-jump');
        belt.resume();
      }, 140);
    }

    function step() {
      var item = track.querySelector('.products-slider__item');
      if (!item) return viewport.clientWidth * 0.8;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { goTo(i); });
      tab.addEventListener('keydown', function (event) {
        var dir = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
        if (!dir) return;
        event.preventDefault();
        var next = (i + dir + tabs.length) % tabs.length;
        tabs[next].focus();
        goTo(next);
      });
    });

    if (prevArrow) prevArrow.addEventListener('click', function () { belt.nudge(-step()); });
    if (nextArrow) nextArrow.addEventListener('click', function () { belt.nudge(step()); });
    if (tabsEl) tabsEl.addEventListener('scroll', tabsFade, { passive: true });

    var down = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;

    viewport.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch') return;
      down = true;
      moved = false;
      startX = event.clientX;
      startScroll = viewport.scrollLeft;
    });

    viewport.addEventListener('pointermove', function (event) {
      if (!down) return;
      var dx = event.clientX - startX;
      if (!moved && Math.abs(dx) > 10) {
        moved = true;
        viewport.classList.add('is-dragging');
        viewport.setPointerCapture(event.pointerId);
      }
      if (moved) viewport.scrollLeft = startScroll - dx;
    });

    function release(event) {
      if (!down) return;
      down = false;
      viewport.classList.remove('is-dragging');
      try { viewport.releasePointerCapture(event.pointerId); } catch (err) {}
    }

    viewport.addEventListener('pointerup', release);
    viewport.addEventListener('pointercancel', release);
    viewport.addEventListener('click', function (event) {
      if (!moved) return;
      moved = false;
      event.preventDefault();
    }, true);

    window.addEventListener('resize', function () {
      window.clearTimeout(jumpT);
      tabsFade();
    }, { passive: true });

    belt = window.UrbPsBelt.create(root, {
      viewport: viewport,
      track: track,
      speed: parseFloat(root.dataset.psSpeed),
      delay: parseFloat(root.dataset.psResume) * 1000,
      auto: root.dataset.psAutoplay === 'true' && !reduce,
      onBuild: measure,
      onMove: onMove
    });

    belt.start();
  }

  function initAll() {
    document.querySelectorAll('.products-slider[data-section-id]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.products-slider[data-section-id]');
    if (root) initSection(root);
  });
})();
